import {lsGet, lsRemove, lsSet} from "@/utils/index";
import Vue from "vue";

const TokenKey = 'token'
const UserKey = 'user'

export function getToken() {
    // eslint-disable-next-line no-console
    // console.log('geToken', token)
    return lsGet(TokenKey)
    // return localStorage.getItem(TokenKey)
}

export function setToken(token) {
    // 管理系统用sessionStorage更合适，同时配置信息及时获取
    return lsSet(TokenKey, token)
    // return localStorage.setItem(TokenKey, token)
}

export function removeToken() {
    return lsRemove(TokenKey)
}

/**
 * 获取当前登录用户信息
 * @returns {*|{unionid: null, sex: null, avatar: null, dt_userid: string, deleted_at: null, is_bind_dd: null, bool_admin: null, organization: null, name: null, id: number, email: null, username: null, status: null}}
 */
export function getAuthUser() {
    return localStorage.getItem(UserKey) ? JSON.parse(localStorage.getItem(UserKey)).value : {
        "id": -1,
        "name": null,
        "email": null,
        "username": null,
        "sex": null,
        "avatar": null,
        "bool_admin": null,
        "status": null,
        "deleted_at": null,
        "is_bind_dd": null,
        "unionid": null,
        "dt_userid": "",
        "organization": null
    }
}

export function setAuthUser(user) {
    Vue.ls.set(UserKey, user);
}

/**
 * 是否是组长
 * @returns boolean
 */
export function boolTeamLeader() {
    const {organization} = getAuthUser()
    return !!(organization && organization.bool_leader)
}

/**
 * 退出
 */
export function logoutClear() {
    lsRemove('token');
    lsRemove('user');
    lsRemove('userAuth');
    lsRemove('userPermissions');
    lsRemove('showBindDD');
    lsRemove('showBindFeishu');
}
